import React, { useMemo, useState } from 'react';

import { IonItemOption } from '@ionic/react';

import { useModal } from 'components/Modal';
import ReorderList from 'components/ReorderList';
import { SelectPicker } from 'components/Select';

import AvailableColumns from './AvailableColumns';
import './index.css';

export default ({
  value: initialValue,
  data,
  error,
  onSubmit,
  onClose,
}: any) => {
  const [value, setValue] = useState(
    () =>
      initialValue.filter((id: any) =>
        data?.some((item: { id: any }) => item.id === id)
      ) || []
  );

  const dataList = useMemo(
    () => value.map((id: number) => data.find((item: any) => item.id === id)),
    [value, data]
  );

  const handleReorder = (value: any[]) => {
    setValue(value.map(({ id }: any) => id));
  };

  const handleRemove = (id: number | string) => {
    setValue(value.filter((item: number | string) => item !== id));
  };

  const handleSubmit = () => {
    onSubmit(value);
  };

  const [showColumnsPickerModal] = useModal(AvailableColumns, {
    value: value,
    data: data,
    error: error,
  });

  const handleOpenColumnsPickerModal = () => {
    showColumnsPickerModal({
      onSubmit: (value: number[]) => {
        setValue(value);
      },
    });
  };

  return (
    <SelectPicker
      data={dataList}
      error={error}
      title={'Columns'}
      multiple={true}
      add={true}
      addText={'Manage'}
      onAdd={handleOpenColumnsPickerModal}
      onSubmit={handleSubmit}
      onClose={onClose}
      components={{
        DataList: ReorderList,
      }}
      DataListProps={{
        onReorder: handleReorder,
      }}
      secondaryActions={({ id }: any) => (
        <IonItemOption onClick={() => handleRemove(id)} color={'danger'}>
          Delete
        </IonItemOption>
      )}
    />
  );
};
